export default {
  // firebase: {
  //   apiKey: 'AIzaSyBA2A-3bqTr959nPv8Um-GB7Ls-mMF2lVU',
  //   projectId: 'fee-calc-stage',
  //   authDomain: "fee-calc-stage.firebaseapp.com",
  //   databaseURL: "https://fee-calc-stage.firebaseio.com"
  // },
  firebase: {
    apiKey: 'AIzaSyCUf7JimgNUu_VnjVtEf8ybKvA7G2z1KWY',
    projectId: 'mr-fee-calc-mobile',
    authDomain: "mr-fee-calc-mobile.firebaseapp.com",
    databaseURL: "https://mr-fee-calc-mobile.firebaseio.com/"
  }
}